import { Loader } from 'semantic-ui-react'

const centered: React.CSSProperties = {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '60vh',
  padding: '2rem',
  textAlign: 'center'
}

export const BootstrapLoading = () => (
  <div style={centered} role="status" aria-live="polite">
    <Loader active inline="centered" />
    <p>Loading your water quality dashboard…</p>
  </div>
)

export const BootstrapRedirecting = () => (
  <div style={centered} role="status" aria-live="polite">
    <Loader active inline="centered" />
    <p>Taking you to the right place…</p>
  </div>
)

// Reached when the API cannot be contacted at all. Previously a blank page.
export const BootstrapUnavailable = () => (
  <div style={centered} role="alert">
    <h1>This dashboard is temporarily unavailable</h1>
    <p>
      We could not load this water system&rsquo;s information. This is usually
      temporary — please try again in a few minutes.
    </p>
    <p>
      If it keeps happening, contact{' '}
      <a href="mailto:support@120water.com">support@120water.com</a>.
    </p>
  </div>
)
